import { createContext, useContext } from "react";

type MenuMode = "portal" | "inline";
const MenuModeContext = createContext<MenuMode>("portal");

export function useMenuMode(): MenuMode {
  return useContext(MenuModeContext);
}

export { MenuModeContext };
